import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {sortData} from "../pages/utils";
import SortAndAddNew from "./SortAndAddNew";
import DrugsAccordion from "./DrugsAccordion";

const DrugsTable = ({
                      patDrugs,
                      onDeleteDrug,
                      onAddDrug,
                      loading,
                      printView = false,
                    }) => {
  const {t: t} = useTranslation();

  const [sortConfig, setSortConfig] = useState({
    key: "startDate",
    ascending: false,
  });

  const [sortedPatDrugs, setSortedPatDrugs] = useState(
    patDrugs ? [...patDrugs] : [],
  );

  useEffect(() => {
    const sorted = sortData(sortConfig?.key, patDrugs, sortConfig?.ascending,
        item => item[sortConfig?.key]);

    setSortedPatDrugs(sorted);
  }, [patDrugs, sortConfig]);


  return (
    <>
      <SortAndAddNew showSorting={ !printView && sortedPatDrugs?.length > 0 } sortConfig={ sortConfig }
                     onAddDrug={ onAddDrug } loading={ loading }  setSortConfig={ setSortConfig }/>
      <div
        className={
          printView ? "w3-container" : "w3-container drugs-content-scroll"
        }
      >
        { sortedPatDrugs?.length > 0 ? (
          <div className="w3-container">
            <DrugsAccordion sortedPatDrugs={ sortedPatDrugs } printView={ printView } onDeleteDrug={ onDeleteDrug } />
          </div>
        ) : (
          !loading && (
            <p className="w3-center">
              { t("you_have_not_yet_entered_any_medication") }
            </p>
          )
        ) }
      </div>
    </>
  );
};

export default DrugsTable;
